export const InstagramIframe: React.FC<InstagramEmbedProps> = ({ src }) => {
    return (
        <iframe
            className='instagram-media instagram-media-rendered instagram-iframe'
            src={`https://www.instagram.com/${src}/embed`}>
        </iframe>
    )
}